import { CalendarDays, ShieldCheck } from 'lucide-react';
import { Button } from './ui/button';
import type { DocumentAccessNotice as Notice } from '../../utils/protectedDocuments';

interface DocumentAccessNoticeProps {
  notice: Notice;
  onDismiss?: () => void;
}

export function DocumentAccessNotice({ notice, onDismiss }: DocumentAccessNoticeProps) {
  const openAction = () => {
    if (!notice.primaryAction?.url) return;
    if (/^https?:\/\//i.test(notice.primaryAction.url)) {
      window.open(notice.primaryAction.url, '_blank', 'noopener,noreferrer');
    } else {
      window.location.href = notice.primaryAction.url;
    }
  };

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm text-[#242424]">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-white p-2 text-amber-600">
          <ShieldCheck className="h-4 w-4" />
        </div>
        <div className="flex-1 space-y-2">
          <div>
            <h4 className="font-semibold text-[#242424]">{notice.title}</h4>
            <p className="mt-1 text-sm leading-6 text-[#5b5b5b]">{notice.message}</p>
            {notice.secondaryMessage && (
              <p className="mt-1 text-xs leading-5 text-[#6b6b6b]">{notice.secondaryMessage}</p>
            )}
          </div>
          <div className="flex flex-wrap gap-2">
            {notice.primaryAction && (
              <Button size="sm" className="gap-2" onClick={openAction}>
                <CalendarDays className="h-4 w-4" />
                {notice.primaryAction.label}
              </Button>
            )}
            {onDismiss && (
              <Button size="sm" variant="outline" onClick={onDismiss}>
                Dismiss
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}